import { component } from 'picoapp';
import Swiper from 'swiper';
// import Swiper styles
import { Navigation, Thumbs } from 'swiper/modules';

export default component((node) => {


    var swiperThumbnails = new Swiper('.swiper-thumbnails', {
        modules: [Navigation, Thumbs],
        slidesPerView: 3,
        spaceBetween: 5,
        breakpoints: {
            1100: {
                slidesPerView: 'auto',
                spaceBetween: 5,
                direction: 'vertical',
            }
        }
    });

    // Initialize the main gallery swiper and link it to the thumbnail swiper
    var swiperGallery = new Swiper('.swiper-gallery', {
        modules: [Navigation, Thumbs],
        slidesPerView: 1,
        spaceBetween: 0,
        thumbs: {
            swiper: swiperThumbnails, // Link to the thumbnails swiper
        },
        navigation: {
            nextEl: '.swiper-button-next', // Navigation button for next
            prevEl: '.swiper-button-prev', // Navigation button for previous
        },
    });


});

